import { Box, Button, Icon, Text, TogglerCheckbox } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import i18n from 'modules/core/lib/i18n'

interface Props {
  convertHours: boolean
  setConvertHours: (value: boolean) => void
  setConvertHoursInsight: (value: boolean) => void
}

const ConvertedHoursToggle = ({ convertHours, setConvertHours, setConvertHoursInsight }: Props) => {
  const title = i18n.t(
    'shift_management.time_insights.time_balance_content.conversion_toggle.title_new'
  )
  const description = i18n.t(
    'shift_management.time_insights.time_balance_content.conversion_toggle.description'
  )

  const onToggleCheckbox = (value: boolean) => {
    setConvertHours(value)
    setConvertHoursInsight(value)
  }

  return (
    <PopoverMenu type="list">
      <PopoverMenu.Trigger>
        <Button type="secondary" iconName="eye-visible" />
      </PopoverMenu.Trigger>
      <PopoverMenu.Content side="bottom" align="end" width="s360">
        <Box paddingY="s12" paddingRight="s24" paddingLeft="s32" justifyContent="center">
          <Box flexDirection="row" justifyContent="flexStart" gap="s4">
            <Box paddingY="s4" justifyContent="flexStart">
              <Icon.Small icon="circle" color="malibu1000" />
            </Box>
            <Box gap="s4">
              <Box flexDirection="row" justifyContent="spaceBetween" gap="s12">
                <Text.Normal weight="medium">{title}</Text.Normal>
                <TogglerCheckbox value={convertHours} onChange={onToggleCheckbox} />
              </Box>
              <Box>
                <Text.Normal>{description}</Text.Normal>
              </Box>
            </Box>
          </Box>
        </Box>
      </PopoverMenu.Content>
    </PopoverMenu>
  )
}

export default observer(ConvertedHoursToggle)
